import { render } from "./MWEditPresentation.vue?vue&type=template&id=36daa588"
import script from "./MWEditPresentation.vue?vue&type=script&lang=js"
export * from "./MWEditPresentation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__